import React from 'react';
import { usePaginator } from '../../Paginator.provider';
import { PageLinkButton, PageLinkButtonProps } from '../../components/PageLinkButton';

type Props = PageLinkButtonProps;

export const PrevPageLink: React.VFC<Props> = (props) => {
  const { options } = usePaginator();
  return (
    <PageLinkButton
      {...options.prevPageLink}
      {...props}
      data-test="prev-page-button"
      iconClassName="pi icon-arrow-left"
    />
  );
};

export type { Props as PrevPageLinkProps };
